module.exports = __webpack_public_path__ + "img/moonbig_blue.bf762b06.svg";